module.exports = __webpack_public_path__ + "media/images/prevention_form/kennenlernen-9af9b8440030c9437014331e0830d8dd.svg";